export { default } from './Cos';
